import { ListItem, ListItemContent } from '@/components/elements/lists';
import { InitialsAvatar } from '@/components/elements/redesign/Avatar';
import Icon from '@/components/icons/Icon';

type UserInfoProps = EmailRequiredProps | NameRequiredProps | PhoneRequiredProps;

type EmailRequiredProps = {
  name?: string;
  phone?: string;
  email: string;
  onClick?: () => void;
  initials?: string;
};

type NameRequiredProps = {
  name: string;
  phone?: string;
  email?: string;
  onClick?: () => void;
  initials?: string;
};

type PhoneRequiredProps = {
  name?: string;
  phone: string;
  email?: string;
  onClick?: () => void;
  initials?: string;
};

const UserInfo = ({ name, phone, email, onClick, initials = '' }: UserInfoProps) => {
  const formatPhone = (phone?: string) => {
    if (!phone) return '';
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, '');
    // Swedish phone numbers: +46 XX XXX XX XX or 0XX XXX XX XX
    if (digits.startsWith('46')) {
      // International format without +
      return digits.replace(/^46(\d{2})(\d{3})(\d{2})(\d{2})$/, '+46 $1 $2 $3 $4');
    } else if (digits.startsWith('0')) {
      // National format
      return digits.replace(/^0(\d{2})(\d{3})(\d{2})(\d{2})$/, '0$1 $2 $3 $4');
    }
    // Fallback: return as is
    return phone;
  };

  return (
    <div className="flex flex-col">
      <ListItem
        leftSlot={
          <InitialsAvatar size="md" bgColor="#DBB4E5" textColor="#092A4E" variant="default" initials={initials} />
        }
        onClick={onClick}
        rightSlot={<Icon variant="chevron-right" />}>
        <ListItemContent content={formatPhone(phone)} subTitle={email} title={name} />
      </ListItem>
    </div>
  );
};

export default UserInfo;
